<script>
export default {
  skipMiddleware: ['checkAuth'],
  name: 'ContractJp'
}
</script>

<template lang="pug" src="./template.pug"></template>
<style lang="scss" src="./style.scss" scoped></style>
